/* DecisionItem.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./DecisionItem.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import DecisionIcon from '@atlaskit/icon/core/migration/decision--editor-decision';
import Item from './Item';
var iconStyles = null;
var iconStylesWithPlaceholder = null;
var DecisionItem = function DecisionItem(_ref) {
  var appearance = _ref.appearance,
    children = _ref.children,
    contentRef = _ref.contentRef,
    placeholder = _ref.placeholder,
    showPlaceholder = _ref.showPlaceholder,
    dataAttributes = _ref.dataAttributes;
  var icon = /*#__PURE__*/React.createElement("span", {
    contentEditable: false,
    className: ax(["_16jlidpf _1o9zidpf _i0dlexct _4t3i7vkz _1bsb7vkz _19pk1b66 _2hwxutpp _otyridpf _18u0idpf _syaz1yjp _1e0c1txw _4cvr1h6o _1bah1h6o", showPlaceholder && "_syaz1oju"])
  }, /*#__PURE__*/React.createElement(DecisionIcon, {
    label: "Decision",
    spacing: "spacious",
    color: "currentColor",
    LEGACY_size: "large"
  }));
  return /*#__PURE__*/React.createElement(Item, {
    appearance: appearance,
    contentRef: contentRef,
    icon: icon,
    placeholder: placeholder,
    showPlaceholder: showPlaceholder,
    itemType: "DECISION",
    dataAttributes: dataAttributes
  }, children);
};
export default DecisionItem;